import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ModalController, AlertController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoAdmHierarquiaAddPage } from '../grupo-adm-hierarquia-add/grupo-adm-hierarquia-add.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { ImagePipe } from 'src/app/pipes/image/image';
import { UserProvider } from 'src/app/services/user/user';

@Component({
  selector: 'app-grupo-adm-hierarquia',
  templateUrl: './grupo-adm-hierarquia.page.html',
  styleUrls: ['./grupo-adm-hierarquia.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule
  ],
})
export class GrupoAdmHierarquiaPage implements OnInit {
  idGrupo: any;
  hierarquiaList: any = [];
  tipo: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    private translate: TranslateService,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public userProvider: UserProvider,
  ) {
    this.idGrupo = this.navParams.get('idGrupo');
    this.tipo = this.navParams.get('tipo');
    this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data) => {
      this.hierarquiaList = data;
    });
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async selecionarHierarquiaNova(funcao: any) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Opções'),
      buttons: [
        {
          text: this.translate.instant('Vincular Pessoa'),
          handler: async () => {
            var data = { funcao: funcao, idGrupo: this.idGrupo };
            const modalPage = await this.modalCtrl.create({ component: GrupoAdmHierarquiaAddPage, componentProps: data });
            modalPage.present();

            (await modalPage.onWillDismiss()).data
            this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data) => {
              this.hierarquiaList = data;
            });
          }
        }
      ]
    });

    actionSheet.present();
  }

  async selecionarHierarquia(f: { hierarquiaGrupoFuncao: { id: any; }; }) {
    if (this.userProvider.hasConfig(241)) {
      return;
    }

    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Opções'),
      buttons: [
        {
          text: this.translate.instant('Editar Vinculo'),
          handler: async () => {
            var data = { funcao: f, idGrupo: this.idGrupo };
            const modalPage = await this.modalCtrl.create({ component: GrupoAdmHierarquiaAddPage, componentProps: data });
            modalPage.present();

            (await modalPage.onWillDismiss()).data
            this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data) => {
              this.hierarquiaList = data;
            });
          }
        },
        {
          text: this.translate.instant('Desvincular Pessoa'),
          handler: async () => {
            let alert = await this.alertCtrl.create({
              cssClass: "alerta-personalizado",
              mode: "ios",
              header: this.translate.instant('Atenção'),
              message: this.translate.instant('Deseja desvincular essa pessoa dessa função?'),
              buttons: [
                {
                  text: this.translate.instant('Não'),
                  handler: () => { }
                },
                {
                  text: this.translate.instant('Sim'),
                  handler: async () => {
                    this.grupoProvider.removerHierarquia(f.hierarquiaGrupoFuncao.id).subscribe(async data => {
                      this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data) => {
                        this.hierarquiaList = data;
                      });
                      const toast = await this.toastCtrl.create({
                        message: this.translate.instant('Pessoa desvinculada com sucesso!'),
                        duration: 3000
                      });

                      toast.present();
                    });
                  }
                }
              ]
            });
            alert.present();
          }
        },
      ]
    });

    actionSheet.present();
  }
}
